// In-page dialog for `data-turbo-confirm` on the Turbo admin pages, in place of the browser's
// `window.confirm` (installed on `Turbo.config.forms.confirm` by administration_turbo.js).
// Stimulus controllers that ask before a submit await `confirmWithDialog` too.
//
// The dialog goes inside the topmost open Bootstrap modal when there is one: the modal's focus
// trap would otherwise pull the focus back from its buttons.
export function confirmWithDialog (message) {
  return new Promise((resolve) => {
    const root = document.createElement("div")
    root.className = "admin-confirm-dialog"
    root.innerHTML = `
      <div class="admin-confirm-dialog__overlay" data-confirm-dialog-overlay></div>
      <div class="admin-confirm-dialog__panel">
        <div class="admin-confirm-dialog__dialog" role="alertdialog" aria-modal="true" aria-labelledby="admin-confirm-dialog-message">
          <p id="admin-confirm-dialog-message" class="admin-confirm-dialog__message"></p>
          <div class="admin-confirm-dialog__actions">
            <button type="button" class="btnv2 btnv2--ghost-light" data-confirm-dialog-cancel></button>
            <button type="button" class="btnv2 btnv2--dark" data-confirm-dialog-ok></button>
          </div>
        </div>
      </div>
    `

    root.querySelector(".admin-confirm-dialog__message").textContent = message
    const cancelButton = root.querySelector("[data-confirm-dialog-cancel]")
    const okButton = root.querySelector("[data-confirm-dialog-ok]")
    cancelButton.textContent = metaContent("turbo-confirm-cancel", "Annuler")
    okButton.textContent = metaContent("turbo-confirm-ok", "Confirmer")

    const finish = (answer) => {
      document.removeEventListener("keydown", onKeyDown, true)
      root.remove()
      resolve(answer)
    }
    // Capture phase, stopped there: Escape closes the dialog only, not the modal around it.
    const onKeyDown = (event) => {
      if (event.key !== "Escape") return

      event.preventDefault()
      event.stopPropagation()
      finish(false)
    }

    root.querySelector("[data-confirm-dialog-overlay]").addEventListener("click", () => finish(false))
    cancelButton.addEventListener("click", () => finish(false))
    okButton.addEventListener("click", () => finish(true))
    document.addEventListener("keydown", onKeyDown, true)

    dialogHost().appendChild(root)
    cancelButton.focus()
  })
}

export function installTurboConfirm (Turbo) {
  if (!Turbo?.config?.forms) return

  Turbo.config.forms.confirm = confirmWithDialog
}

function dialogHost () {
  const openModals = [...document.querySelectorAll(".modal.show")]
  if (!openModals.length) return document.body

  return openModals.reduce((top, modal) => (zIndex(modal) >= zIndex(top) ? modal : top))
}

function zIndex (element) {
  return Number.parseInt(window.getComputedStyle(element).zIndex, 10) || 0
}

function metaContent (name, fallback) {
  return document.querySelector('meta[name="' + name + '"]')?.content || fallback
}
